import { ReactComponent as LinkArrowSvg } from '../../assets/icons/link-arrow.svg';

export const LinkArrowIcon: SvgIcon = (props) => {
    return <LinkArrowSvg {...props} />;
};
